document.addEventListener("DOMContentLoaded", function () {
  const sections = document.querySelectorAll('[data-section-type="background-video"]');

  sections.forEach((section) => {
    const container = section.querySelector(".video-container");
    const videoWrapper = container.querySelector(".video-container__video");
    const videoUrl = container.dataset.videoUrl;
    const videoId = container.dataset.videoId;
    const autoplay = container.dataset.videoAutoplay === "true";
    const loop = container.dataset.videoLoop === "true";
    const isMobile = window.innerWidth < 768;

    if (!videoUrl || !videoWrapper || isMobile) return;

    let embedCode = "";

    if (videoUrl.includes("youtube.com") || videoUrl.includes("youtu.be")) {
      const id = videoId || extractYouTubeID(videoUrl);
      embedCode = `
        <iframe 
          src="https://www.youtube.com/embed/${id}?autoplay=${autoplay ? 1 : 0}&loop=${loop ? 1 : 0}&mute=1&playlist=${id}&controls=0&modestbranding=1&showinfo=0&rel=0&enablejsapi=1"
          frameborder="0"
          allow="autoplay; fullscreen"
          allowfullscreen
          style="width:100%; height:100%; position:absolute; top:0; left:0; object-fit:cover;">
        </iframe>`;
    } else if (videoUrl.includes("vimeo.com")) {
      const id = videoId || videoUrl.split("/").pop();
      embedCode = `
        <iframe
          src="https://player.vimeo.com/video/${id}?autoplay=${autoplay ? 1 : 0}&loop=${loop ? 1 : 0}&muted=1&background=1"
          frameborder="0"
          allow="autoplay; fullscreen"
          allowfullscreen
          style="width:100%; height:100%; position:absolute; top:0; left:0;">
        </iframe>`;
    } else if (videoUrl.endsWith(".mp4")) {
      embedCode = `
        <video autoplay loop muted playsinline style="width:100%; height:100%; object-fit:cover; position:absolute; top:0; left:0;">
          <source src="${videoUrl}" type="video/mp4">
        </video>`;
    }

    if (embedCode) {
      videoWrapper.innerHTML = embedCode;
      container.classList.add("video--init");
      if (container.classList.contains("video-container--background")) {
        const adjustBackgroundVideo = () => {
          const media = container.querySelector(".video-container__media");
          const wrapper = container.querySelector(".video-container__video");
          const frame = wrapper.querySelector("iframe, video");
      
          if (!frame) return;
      
          const containerWidth = (media || container).offsetWidth;
          const containerHeight = (media || container).offsetHeight;
          const containerRatio = containerWidth / containerHeight;
      
          const frameWidth = parseInt(frame.getAttribute("width")) || 640;
          const frameHeight = parseInt(frame.getAttribute("height")) || 360;
          const frameRatio = frameWidth / frameHeight;
      
          const vCrop = 75; // to help push the UI off-screen
      
          if (containerRatio > frameRatio) {
            const videoHeight = containerWidth / frameRatio + vCrop * 2;
            wrapper.style.marginTop = `${(containerHeight - videoHeight) / 2 - vCrop}px`;
            wrapper.style.marginInlineStart = "";
            wrapper.style.height = `${videoHeight}px`;
            wrapper.style.width = "";
          } else {
            const videoWidth = containerWidth * frameRatio + vCrop * 2 * frameRatio;
            wrapper.style.marginTop = `${-vCrop}px`;
            wrapper.style.marginInlineStart = `${(containerWidth - videoWidth) / 2}px`;
            wrapper.style.height = `${containerHeight + vCrop * 2}px`;
            wrapper.style.width = `${videoWidth}px`;
          }
        };
      
        // Initial call
        adjustBackgroundVideo();
      
        // Responsive recalculation
        window.addEventListener("resize", adjustBackgroundVideo);
      }



    }
  });

  function extractYouTubeID(url) {
    try {
      const parsed = new URL(url);
      if (parsed.hostname === "youtu.be") return parsed.pathname.slice(1);
      return parsed.searchParams.get("v");
    } catch {
      return null;
    }
  }
});

